export function decomposeLine(entity) {
    /* start/end width, bulge - seems cannot be present, at least with current parser */
    if (entity.vertices.length !== 2) {
        return [];
    }
    return entity.vertices;
}
//# sourceMappingURL=decomposeLine.js.map